// extracted by mini-css-extract-plugin
module.exports = {"main":"DetailedButton_main__3u8o3","image":"DetailedButton_image__UvGpz","textContainer":"DetailedButton_textContainer__1ouiu"};